import { render, staticRenderFns } from "./result.vue?vue&type=template&id=5ac00592&scoped=true&"
import script from "./result.vue?vue&type=script&lang=ts&"
export * from "./result.vue?vue&type=script&lang=ts&"
import style0 from "./result.vue?vue&type=style&index=0&id=5ac00592&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac00592",
  null
  
)

export default component.exports